define('views/conversations/Podio.Views.Conversations.Base.Show',['require','translate','underscore','jquery','jquery.scrollTo','moment','lib/backbone/Backbone.PodioView','lib/backbone/Backbone.Mixins.PodioInfiniteScrollView','views/conversations/Podio.Views.Conversations.Message','views/conversations/Podio.Views.Conversations.UserEvent','views/lib/Podio.Views.Composer','lib/Podio.UI.SimpleInlineEdit','lib/Podio.UI.Tooltips','lib/Podio.Utils','lib/Podio.UI.Gifs','jst!shared/generic_loader_small','jst!conversations/_show','jst!conversations/_divider','lib/Podio.UI.Modal'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('jquery.scrollTo');
  var moment = require('moment');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var MixinInfiniteScrollView = require('lib/backbone/Backbone.Mixins.PodioInfiniteScrollView');
  var ViewConversationMessage = require('views/conversations/Podio.Views.Conversations.Message');
  var ViewConversationUserEvent = require('views/conversations/Podio.Views.Conversations.UserEvent');
  var ViewComposer = require('views/lib/Podio.Views.Composer');
  var SimpleInlineEdit = require('lib/Podio.UI.SimpleInlineEdit');

  var Tooltips = require('lib/Podio.UI.Tooltips');
  var podioUtils = require('lib/Podio.Utils');
  var podioGifs = require('lib/Podio.UI.Gifs');

  var jstGenericLoaderSmall = require('jst!shared/generic_loader_small');
  var jstShow = require('jst!conversations/_show');
  var jstDivider = require('jst!conversations/_divider');
  var modals = require('lib/Podio.UI.Modal');

  var conversationsShowBase = PodioView.extend({
    _initInfiniteScroll: function() {
      this.elmItemsContainer = this.elmEventsContainer;
      this.elmItemsList = this.elmEvents;
    },

    _adjustHeight: function() {
      if (this.elmEventsContainer) {
        var conversationHeaderHeight = 0;
        if (this.elmHeader) {
          conversationHeaderHeight = this.elmHeader.outerHeight();
        }
        var height = this.elmWindow.height() - conversationHeaderHeight;
        this.elmEventsContainer.css('height', height + 'px');
      }
    },

    _initInlineEditor: function() {
      if (this.inlineEditor) {
        this.inlineEditor.dispose();
      }

      var self = this;
      this.inlineEditor = new SimpleInlineEdit({
        elm: this.elmHeader.find('.subject'),
        callback: function(val) {
          self.eventBus.trigger('showConversation:subjectChanged', self.model, val);
        }
      });
    },

    onAddPeopleClicked: function(elmTarget, e) {
      this.trigger('showConversation:addPeople', this.model);
    },
  
    onLeaveConversationClicked: function(elmTarget, e) {
      this.trigger('showConversation:leaveConversation', this.model);
    },

    onMarkUnreadClick: function() {
      this.model.markUnread();
      this.trigger('showConversation:markUnread', this.model);
    },

    onStarClick: function(elmTarget, e) {
      this.model.star();
      this.trigger('showConversation:star', this.model);
    },

    onUnstarClick: function(elmTarget, e) {
      this.model.unstar();
      this.trigger('showConversation:unstar', this.model);
    },
    scrollToBottom: function(shouldAnimate) {
      Tooltips.hideAll(); // Hide all tooltips, since we are scrolling, so positions are changing.
      this.elmEventsContainer.scrollTo('max', shouldAnimate ? 200 : 0, { axis: 'y' });
    },

    renderWaiting: function() {
      this.elmTarget.attr('data-conversation-id', '');
      this.elmTarget.html(this.getTemplate(jstGenericLoaderSmall));
    },

    renderEvent: function(event, col, options, template) {
      var html;
      var prevEvent;

      this.trigger('showConversation:beforeEventRendered', event);

      if (options.fresh && this.bottomMostEvent) {
        prevEvent = this.bottomMostEvent;
      } else if (col) {
        prevEvent = col.at(col.indexOf(event) + 1);
      }

      var coalesce = this.shouldCoalesceEvents(event, prevEvent);

      switch (event.get('action')) {
      case 'message':

        var isFresh = options && options.fresh === true;
        var messageView = new ViewConversationMessage({
          model: event,
          template: template,
          fresh: isFresh,
          coalesce: coalesce
        });

        html = messageView.render().el;
        if (podioUtils.showFeature('gif_pause')) {
          podioGifs.pauseGifs(html);
        }

        if (isFresh) {
          _.delay(function() {
            messageView.markAsStale();
          }, 5000);
        }

        break;
      case 'participant_add':
      case 'participant_leave':
      case 'live_start':
      case 'live_end':
      case 'live_accept':
      case 'live_decline':
      case 'subject_change':
        var userEventView = new ViewConversationUserEvent({
          model: event
        });
        html = userEventView.render().el;
        break;
      }

      if (!coalesce) {
        var dividerText = this.dividerText(event, prevEvent);

        var divider = this.getTemplate(jstDivider, {
          dividerText: dividerText
        });

        $(html).prepend(divider);
      }

      $(html).attr('data-message-id', event.get('id'));

      if (options.fresh) {
        this.elmEvents.append(html);
        this.bottomMostEvent = event;
      } else {
        this.elmEvents.prepend(html);
      }
      this.trigger('showConversation:eventRendered', event);
    },

    renderComposer: function(options) {
      if (this.composerView) {
        this.composerView.dispose();
      }

      options = _.extend({
        elmContainer : this.elmPresenceBar, // It inserts after the given elm, not inside it
        eventBus: this.eventBus,
        hiddenComposerActions: true,
        hideQuestions: true,
        divInsteadOfForm: false,
        canEmoji: true,
        charCount: 'char-count',
        customClass: 'message-composer-new',
        translations: {
          inputPlaceholder: t('Add a message #conversations'),
          submitButton: t('Add message #conversations')
        },
        takeFocus: true
      }, options || {});

      this.composerView = new ViewComposer(options);

      this.composerView.render();
    },

    restoreComposer: function() {
      this.composerView.restoreComposer();
    },

    setComposerInput: function(text) {
      this.composerView.setInput(text);
    },

    render: function(customTemplate, options) {
      this.elm.append(this.getTemplate(customTemplate || jstShow, {
        conversation: this.model,
        translations: {
          started_on: t('Started on {0} #conversations')
        }
      }));

      this.elmEventsContainer = this.elm.find('.events-container');
      this.elmEvents = this.elmEventsContainer.find('.events');
      this.elmPresenceBar = this.elmEventsContainer.find('.conversation-presence-bar-wrapper');
      this.collection.each(function(event) {
        this.renderEvent(event, this.collection, {});
      }, this);

      this.elmTarget.attr('data-conversation-id', this.model.get('conversation_id'));
      this.elmTarget.html(this.elm);

      this.renderComposer(options);

      var self = this;
      _.defer(function() {
        self.scrollToBottom();
      });

      return this;
    },

    isComposerFullyVisible: function() {
      if (this.composerView) {
        return this.composerView.isFullyVisible();
      } else {
        return false;
      }
    },

    shouldCoalesceEvents: function(event, prevEvent) {
      return prevEvent &&
             event.get('action') === 'message' && prevEvent.get('action') === 'message' &&
             event.get('created_by').get('id') === prevEvent.get('created_by').get('id') &&
             event.createdOn().diff(prevEvent.createdOn(), 'minutes') <= 20;
    },

    dividerText: function(event, prevEvent) {
      if (!prevEvent) {
        return false;
      }

      var dateA = event.createdOn().startOf('day'),
        dateB = prevEvent.createdOn().startOf('day'),
        today = moment().startOf('day');

      if (dateA.diff(dateB) === 0) {
        return false;
      } else if (dateA.diff(today) === 0) {
        return t('today #conversation');
      } else if (today.clone().startOf('week').diff(dateA.clone().startOf('week')) === 0) {
        return dateA.format('dddd');
      } else {
        return dateA.format('LL');
      }
    }

  });

  _.extend(conversationsShowBase.prototype, MixinInfiniteScrollView);

  // Override methods in Infinite Scroll View mixin
  _.extend(conversationsShowBase.prototype, {
    _showLoader: function() {
      var elmLoader = $('<li class="conversation-event-loader">' + this.getTemplate(jstGenericLoaderSmall) + '</li>');
      this.elmEvents.prepend(elmLoader);
    },

    _removeLoader: function() {
      var elmLoader = this.elmEvents.find('.conversation-event-loader');
      this.elmEventsContainer.scrollTo(elmLoader, { offset: this.headerHeight * -1 });
      elmLoader.remove();
    }
  });

  return conversationsShowBase;

});

